function initReassignSelects() {
  // Use window.jQuery (the dist build set by require("jquery")) rather than the
  // ProvidePlugin $ (jquery/src/jquery — a different instance). CDN select2
  // extends window.jQuery.fn, not the ProvidePlugin instance, so $.fn.select2
  // would be undefined otherwise.
  var jQuery = window.jQuery;
  if (!jQuery || typeof jQuery.fn.select2 === 'undefined') return;
  if (!document.getElementById('reassign-member')) return;
  if (jQuery('#reassign-member').hasClass('select2-hidden-accessible')) return;

  jQuery('#reassign-member').select2({
    minimumInputLength: 0,
    placeholder: 'Select member',
    allowClear: false,
    ajax: {
      url: '/teams/search',
      dataType: 'json',
      delay: 250,
      data: function(params) { return { name: params.term }; },
      processResults: function(data) { return { results: data }; },
      cache: true
    },
    templateResult: function(team) { return team.full_name || team.text; },
    templateSelection: function(team) { return team.full_name || team.text; }
  });

  jQuery('#reassign-county').select2({
    minimumInputLength: 0,
    placeholder: 'Select county',
    allowClear: false,
    ajax: {
      url: '/vehicles/search_county',
      dataType: 'json',
      delay: 250,
      data: function(params) { return { query: params.term, page: params.page }; },
      processResults: function(data, params) {
        params.page = params.page || 1;
        return {
          results: data.counties,
          pagination: { more: (params.page * 100) < data.counties.length }
        };
      },
      cache: true
    }
  });
}

document.addEventListener('turbolinks:before-cache', function() {
  var jQuery = window.jQuery;
  if (!jQuery || typeof jQuery.fn.select2 === 'undefined') return;
  if (!document.getElementById('reassign-member')) return;
  jQuery('#reassign-member').select2('destroy');
  jQuery('#reassign-county').select2('destroy');
});

document.addEventListener('turbolinks:load', function() { initReassignSelects(); });
